import {NavLink} from "react-router-dom";
import {Fragment, useState} from "react";
import Modal from "react-bootstrap/Modal";

const Index = (props) => {


    const [m, setM] = useState(false)
    return (<Fragment>
        <header>
            {/*<div className="topslider border-bottom" dir="ltr">*/}
            {/*    <div className="marquee py-2 d-inline-flex text-end">*/}


            {/*        {props.trs && props.trs.map(function (c, i) {*/}

            {/*            return (<div key={'sdsd' + i} className="topcoin-item">*/}
            {/*                <div className="topcoin-info">*/}
            {/*                    <div className="row py-1 px-5" dir="rtl">*/}
            {/*                        <div className="col-7"><img alt={c.alt}*/}
            {/*                                                    src={c.logo}*/}
            {/*                                                    className="avatar avatar-xs ms-1 d-inline-flex"/>*/}
            {/*                            <div*/}
            {/*                                className="text-dark font-bolder text-sm d-inline-flex">{c.name}</div>*/}
            {/*                        </div>*/}
            {/*                        <div className="col-5 text-start top-menu-lh" dir="ltr">*/}
            {/*                            <div*/}
            {/*                                className={"text-" + (parseFloat(c.percent) > 0 ? 'success' : 'danger') + " font-bold en text-sm"}>*/}
            {/*                                <i*/}
            {/*                                    className={"fa fa-arrow-" + (parseFloat(c.percent) > 0 ? 'up' : 'down') + " me-2 text-xs opacity-50"}></i>{c.percent} %*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>)*/}
            {/*        })}*/}


            {/*    </div>*/}
            {/*</div>*/}
            <nav
                className="navbar navbar-main navbar-expand-lg navbar-light bg-white py-3 py-lg-3 px-0 border-bottom"
                id="navbar_main">
                <div className="container-xxl"><NavLink className="navbar-brand d-flex align-items-center ms-5"
                                                        to="/">
                    <img
                        src={props.logo} alt="صرافی ارزهای دیجیتال"/> </NavLink>
                    <button onClick={() => {
                        setM(true)
                    }} className="navbar-toggler ms-n2 me-auto text-start" type="button" data-bs-toggle="modal"
                            data-bs-target="#mobile_nav" aria-label="Toggle navigation"><span
                        className="navbar-toggler-icon"></span></button>
                    <div className="collapse navbar-collapse" id="navbar-main-collapse">
                        <ul className="navbar-nav align-items-lg-center ms-lg-5">
                            <li className="nav-item"><NavLink className="nav-link"
                                                              to={window.config.staticAddress + "/markets"}>
                                قیمت ارز ها

                                </NavLink>
                            </li>

                            {props.auth !== null && <Fragment>
                                <li className="nav-item"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/transactions"}>
                                    تراکنشات
                                </NavLink>
                                </li>
                                <li className="nav-item"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/payments"}>
                                    واریزی ها
                                </NavLink>
                                </li>
                                <li className="nav-item"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/sells"}>
                                    برداشت ها
                                </NavLink>
                                </li>

                            </Fragment>}
                        </ul>
                    </div>
                    <div className="navbar-nav order-lg-3 me-2 d-none d-lg-inline-flex align-items-center"></div>
                    {props.auth === null && <div className="navbar-nav order-lg-5 ms-auto d-none d-lg-inline-flex align-items-center">
                        <NavLink
                            to={window.config.staticAddress + "/auth/login"}
                            className="btn btn-sm btn-neutral text-nowrap shadow-none"> ورود به حساب </NavLink>
                        <NavLink
                            to={window.config.staticAddress + "/auth/register"}
                            className="btn btn-sm btn-primary text-nowrap me-3"> ثبت
                            نام </NavLink>

                    </div>}
                    {props.auth !== null && <div className="navbar-nav order-lg-5 ms-auto d-none d-lg-inline-flex align-items-center">

                        <NavLink
                            to={window.config.staticAddress + "/profile/dashboard"}
                            className="btn btn-sm btn-primary text-nowrap  "> پروفایل من</NavLink>
                        <NavLink
                            onClick={()=>{
                                localStorage.clear()
                                props.setAuth(null)
                            }}
                            to={'#'}
                            className="btn btn-sm btn-neutral text-nowrap shadow-none me-3"> خروج</NavLink>


                    </div>}
                </div>
            </nav>
        </header>


        <Modal show={m} onHide={() => {
            setM(false)
        }}
        >
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body>

                <div className="p-1">
                    <div onClick={() => setM(false)} className="px-6 pt-4 position-relative">
                        <NavLink className="navbar-brand" to="/">
                            <div className="w-md-auto text-dark"><img className="w-20" src={props.logo}
                                                                      alt="صرافی ارزهای دیجیتال"/></div>
                        </NavLink>

                    </div>

                    <div className="px-6 pb-4">
                        <ul className="navbar-nav flex-row flex-wrap pt-4 py-lg-0">

                            {props.trs && props.trs.map(function (c, i) {

                                return (

                                    <li key={'sddfdfdfdffdfdf'+i}  onClick={() => setM(false)}
                                        className="nav-item col-6 col-lg-auto"><NavLink  onClick={()=>{

                                        props.setTraid(c.en)
                                    }}  className="nav-link py-2"
                                                                                        to={window.config.staticAddress +"/trades/" + c.en + ""}>
                                        {c.alt}
                                    </NavLink></li>

                                )
                            })}


                            {props.auth !== null && <Fragment>
                                <li className="nav-item col-6 col-lg-auto"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/transactions"}>
                                    تراکنشات
                                </NavLink>
                                </li>
                                <li className="nav-item col-6 col-lg-auto"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/payments"}>
                                    واریزی ها
                                </NavLink>
                                </li>
                                <li className="nav-item col-6 col-lg-auto"><NavLink className="nav-link"
                                                                  to={window.config.staticAddress + "/profile/sells"}>
                                    برداشت ها
                                </NavLink>
                                </li>

                            </Fragment>}




                        </ul>
                        <hr className="my-4"/>
                       {props.auth === null && <div onClick={() => setM(false)} className="d-block align-items-center text-center"><NavLink
                            to={window.config.staticAddress + "/auth/register"}
                            className="btn btn-primary px-6 py-3 font-bold my-2 btn-sm full-width"> <i
                            className="far fa-user-plus ms-3 opacity-50"></i>ثبت‌ نام </NavLink>
                            <NavLink
                                to={window.config.staticAddress + "/auth/login"}
                                className="btn btn-outline-dark px-6 py-3 font-bold my-2 btn-sm full-width"> ورود به
                                صرافی <i className="far fa-arrow-left me-3 opacity-50"></i> </NavLink></div>}





                       {props.auth !== null &&
                           <div onClick={() => setM(false)} className="d-block align-items-center text-center">
                               <NavLink
                                   to={window.config.staticAddress + "/profile/dashboard"}
                                   className="btn btn-sm btn-primary text-nowrap  "> پروفایل من</NavLink>
                               <NavLink
                                   onClick={()=>{
                                       localStorage.clear()
                                       props.setAuth(null)
                                   }}
                                   to={'#'}
                                   className="btn btn-sm btn-neutral text-nowrap shadow-none me-3"> خروج</NavLink></div>}
                    </div>
                </div>

            </Modal.Body>

        </Modal>


    </Fragment>)
}
export default Index
